<div class="cal-cell-top" (click)="createReminder()">
  <span class="cal-day-number" (click)="openDay(ppDay.date, $event)">{{
    ppDay.date | calendarDate: 'monthViewDayNumber' : ppLocale
  }}</span>
</div>

<section class="calendarReminders">
  @for (reminder of reminders; track reminder; let index = $index) {
    @if (index < 2) {
      <pp-reminder-calendar-element
        [ppReminder]="reminder"
      ></pp-reminder-calendar-element>
    }
    @if (index === 2 && reminders.length > 2) {
      <button
        class="calendarEvent__more"
        (click)="openDay(ppDay.date, $event)"
        >
        <span>+{{ 'x_more' | ppTranslate: { count: reminders.length - 2 } }} </span>
      </button>
    }
  }
</section>
